module.exports = __webpack_public_path__ + "static/media/favicon.c710f059.ico";


//////////////////
// WEBPACK FOOTER
// ./node_modules/loyal-design-system/skins/clubeale/favicon.ico
// module id = 2046
// module chunks = 10